<template>
    <div id="app">
        <!-- <router-view img-set="/static/img/favicon-prod.ico" v-if="isRouterAlive"></router-view> -->
        <router-view img-set="/static/img/favicon-prod.ico" v-if="isRouterAlive && !$route.meta.keepAlive"></router-view>
        <keep-alive>
            <router-view img-set="/static/img/favicon-prod.ico" v-if="isRouterAlive && $route.meta.keepAlive"></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'App',
        provide () {
            return {
                reload: this.reload
            }
        },
        data () {
            return {
                isRouterAlive: true
            }
        },
        mounted(){
            console.log('当前页面地址：',location.href)
        },
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/scss/reset";
    @import "assets/scss/style";
    @import "../../../static/css/font.css";
    @font-face {
        font-family: MarkBlack;
        src: url("../../assets/fonts/MarkBlack-Italic.otf");
    }


    html {
        width: 100%;
        height: 100%;
    }

    body {
        width: 100%;
        height: 100%;
        /*解决滑屏卡顿*/
        overflow-x: hidden;
    }

    #app {
        width: 100%;
        height: 100%;
        /*解决滑屏卡顿*/
        -webkit-overflow-scrolling: touch;
    }

    .mint-indicator .mint-indicator-wrapper, .mint-toast.is-placemiddle {
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    // 商城项目添加，处理sketch自动生成html的css

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .justify-start {
        display: flex;
        justify-content: flex-start;
    }

    .justify-center {
        display: flex;
        justify-content: center;
    }

    .justify-end {
        display: flex;
        justify-content: flex-end;
    }

    .justify-evenly {
        display: flex;
        justify-content: space-evenly;
    }

    .justify-around {
        display: flex;
        justify-content: space-around;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .items-start {
        display: flex;
        align-items: flex-start;
    }

    .items-center {
        display: flex;
        align-items: center;
    }

    .items-end {
        display: flex;
        align-items: flex-end;
    }

</style>



// WEBPACK FOOTER //
// App.vue?29076fd9